import { fetchConToken } from '../helpers/fetch';

export async function reconciliationRequest(account,path='',body,signal) {
    const response=await fetchConToken(`bancos/reconciliation/${account}${path}`,body,body===undefined?'GET':'POST',{signal});
    if(!response.headers.get('content-type')?.includes('application/json'))throw new Error('Conciliación no disponible. Verifica que el backend esté actualizado.');
    const result=await response.json();
    if(!response.ok || !result.ok)throw new Error(result.msg || 'No se pudo completar la operación.');
    return result.data;
}
export async function downloadStatement(account,importId,filename) {
    const response=await fetchConToken(`bancos/reconciliation/${account}/file/${importId}`);
    if(!response.ok)throw new Error('No se pudo descargar el extracto.');
    const url=URL.createObjectURL(await response.blob());
    const a=document.createElement('a');a.href=url;a.download=filename;a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
